import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DocumentsState } from './state';

export const DocumentsFeature = 'DocumentsFeature';

export const documentFeatureStateSelector = createFeatureSelector<DocumentsState>(DocumentsFeature);

export const selectDocuments = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.documents,
);

export const selectDocumentsLoading = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.loadingDocuments,
);

export const selectDocumentCreating = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.creatingDocument,
);

export const selectCloseCreatingDocumentModal = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.closeCreatingDocumentModal,
);

export const selectDocumentLoading = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.loadingDocument,
);

export const selectUploadingDocumentData = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.uploadingDocumentData,
);

export const selectUploadingDocumentVersionData = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.uploadingDocumentVersionData,
);

export const selectSelectedDocumentFileId = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.selectedDocumentFileId,
);

export const selectSelectedDocumentFileUploadError = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.selectedDocumentFileUploadError,
);

export const selectSelectedDocumentFileUploading = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.selectedDocumentFileUploading,
);

export const selectDocument = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.document,
);

export const selectDocumentEditing = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.editingDocument,
);

export const selectCloseEditingDocumentModal = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.closeEditingDocumentModal,
);

export const selectSendingReport = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.sendingReport,
);

export const selectSendingReportDocument = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.sendingReportDocument,
);

export const selectAskingReportStatus = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.askingReportStatus,
);

export const selectCloseSendingReportModal = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.closeSendingReportModal,
);

export const selectActivePageReviewDocumentUniqueId = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.activePageReviewDocumentUniqueId,
);

export const selectPageReviewProgressByDocumentId = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.pageReviewProgressByDocumentId,
);

export const selectPageReviewResponseDataByDocumentId = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.pageReviewResponseDataByDocumentId,
);

export const selectSelectedPlaybookIdByDocumentId = createSelector(
  documentFeatureStateSelector,
  (state: DocumentsState) => state.selectedPlaybookIdByDocumentId,
);

export const fromDocuments = {
  selectDocuments,
  selectDocumentsLoading,
  selectCloseCreatingDocumentModal,
  selectDocumentCreating,
  selectSelectedDocumentFileId,
  selectSelectedDocumentFileUploadError,
  selectSelectedDocumentFileUploading,
  selectDocument,
  selectDocumentLoading,
  selectUploadingDocumentVersionData,
  selectDocumentEditing,
  selectCloseEditingDocumentModal,
  selectSendingReport,
  selectCloseSendingReportModal,
  selectActivePageReviewDocumentUniqueId,
  selectPageReviewProgressByDocumentId,
  selectPageReviewResponseDataByDocumentId,
  selectSelectedPlaybookIdByDocumentId,
};
